export const assignBodyCSS = () => {
    if (navigator.platform.match('Mac') !== null) {
        document.body.setAttribute('class', 'OSX-body');
    } else {
        document.body.setAttribute('class', 'non-OSX-body');
    }
}